// libs
import styled from 'styled-components';
import { MAX_APP_CONTAINER_WIDTH_NEW } from '@makemydeal/dr-shared-ui-utils';

export const StyledHistoryOfferColumnContainer = styled.div`
    display: flex;
    width: 100%;
    margin-top: 1rem;
`;

export const DealHistoryTitle = styled.h1`
    &&& {
        text-align: left;
    }
`;

export const StyledDealHistoryFooter = styled.div`
    width: 100%;
    height: 3.125rem;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    box-shadow: 0 -0.25px 0.25px 0 rgba(0, 0, 0, 0.2);

    display: grid;
    align-content: center;
    text-align: right;
`;

export const StyledSliderCarouselContainer = styled.div`
    background: #f4f4f4;
    padding: 1.5rem 0;
    border-radius: ${({ theme }) => theme.tokens.ComponentCardBorderRadius};
`;

export const DealHistoryFooterContainer = styled.div<{ $isInDrawer?: boolean }>`
    background: #ffffff;
    position: ${(props) => (props.$isInDrawer ? 'absolute' : 'fixed')};
    bottom: 0;
    left: 0;
    right: 0;
`;

export const DealHistoryFooterInterstateButtonContainer = styled.div<{ $isInDrawer?: boolean }>`
    max-width: ${(props) => (props.$isInDrawer ? 'none' : MAX_APP_CONTAINER_WIDTH_NEW)};
    margin: 0 auto;
`;
